/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmDailyCountInfo } from './EvmDailyCountInfo';
import type { EvmDailyTrxInfo } from './EvmDailyTrxInfo';

export type EvmHomeBurntFeeListInfo = {
    TBF: string;
    HTP: EvmHomeBurntFeeListInfo.HTP;
    DBFLIST: Array<EvmDailyCountInfo>;
    DTRXLIST: Array<EvmDailyTrxInfo>;
};

export namespace EvmHomeBurntFeeListInfo {

    export enum HTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }


}

